// ** Third Party
import PropTypes from "prop-types";
import classnames from "classnames";

// One numbered question on the setup gate. Keeps the heading, the numbering and
// the explanation line reading the same for every question, whichever field
// type answers it. Spacing is the caller's: the questions that share a row sit
// in a grid rather than stacking.
const SetupQuestion = ({ step, title, description, className = "", children }) => (
    <div className={classnames({ [className]: className })}>
        <h2 className="text-sm font-semibold text-gray-900">{`${step}. ${title}`}</h2>
        {description && <p className="mt-1 text-sm text-muted">{description}</p>}
        {children}
    </div>
);

SetupQuestion.propTypes = {
    step       : PropTypes.number.isRequired,
    title      : PropTypes.string.isRequired,
    description: PropTypes.string,
    className  : PropTypes.string,
    children   : PropTypes.node
};

export default SetupQuestion;
